import React from 'react';

const Logo = ({ width = 380, height = 380 }) => {
  return (
    <img
      src={process.env.PUBLIC_URL + '/assets/images/helium500x500.png'}
      style={{
        width: width,
        height: height,
        transition: 'width 0.5s, height 0.5s',
      }}
    />
  );
};

export default Logo;
